export const CurrentClientUserApiRoute = {
  Me: '/cockpit-api/me',
} as const;
